(ns frontend.view.modals.email-viewer.view
  (:require
   [ui.util :as uu]
   [clojure.set :as set]
   [clojure.string :as string]
   [common.entity :as entity]
   [common.features.plan :as plan]
   [common.localization :as loc]
   [common.schema.registry :as schema-registry]
   [common.util :as cu]
   [frontend.actions.entity :as actions-entity]
   [frontend.logging :as logging]
   [frontend.state.current-session :as session]
   [frontend.utils :as fu]
   [frontend.view.entity-viewers.events.editor-utils :as editor-utils]
   [frontend.view.modals.email-viewer.events :as events]
   [reagent.core :as r]
   [ui.components.button.view :as button]
   [ui.components.modal.view :as modal]
   [ui.components.rich-text.tiptap :as tiptap]
   [ui.components.toggle.view :as toggle]))

(defonce rich-text? true)
(defonce modal-key :email-viewer-modal)

(defn viewer-view
  [email-entity]
  (let [html-with-links (fu/eml-txt-body->hyperlinks (:email/body email-entity))
        content (->> html-with-links
                     (fu/sanitize-html))]
    [tiptap/viewer {:value content}]))

;;TIMO Is it outdated

;; (defn render-person-option
;;   [props]
;;   (let [{:keys [:isDisabled
;;                 :value
;;                 :isSelected
;;                 :label
;;                 :isRtl]}
;;         props
;;         person-id (-> props
;;                       (js->clj :keywordize true)
;;                       :value
;;                       (first))
;;         person (get @session/entities person-id)
;;         avatar-url (:person/avatar-url person)
;;         getStyles (:getStyles props)]
;;     [:div
;;      (merge
;;       {:class-name (fu/cs :select-option__contact)}
;;       (:innerProps (js->clj props)))
;;      [:span.select-option__contact__circle
;;       (cond
;;         avatar-url
;;         [:img {:src (fu/sanitize-img-url avatar-url)}]

;;         person
;;         [:span
;;          (str (first (:person/first-name person))
;;               ""
;;               (first (:person/last-name person)))]

;;         :else [:i.fal.fa-at])]
;;      [:span.select-option__contact__label.ml-2
;;       (or (:person/universal-email-address person)
;;           label
;;           (->> value
;;                :label)
;;           (->> value
;;                :new-value))]]))

(defn header-attribute
  [{:keys [:attribute :value]}]
  [:div
   [:label
    (loc/tr attribute) ":"]
   [:span
    value]])

(defn header-block
  [entity]
  [:div
  {:class "m-0 p-3 flex flex-col gap-2 bg-base-regular text-base-regular-text rounded text-sm"} 
   (when (not-empty (string/trim (str (:email/from entity))))
     [header-attribute
      {:value     (:email/from entity)
       :attribute :email/from}])
   (when (not-empty (string/trim (str (:email/to entity))))
     [header-attribute
      {:value     (:email/to entity)
       :attribute :email/to}])
   (when (not-empty (string/trim (str (:email/cc entity))))
     [header-attribute
      {:value     (:email/cc entity)
       :attribute :email/cc}])
   (when (not-empty (string/trim (str (:email/bcc entity))))
     [header-attribute
      {:value     (:email/bcc entity)
       :attribute :email/bcc}])
   (when (not-empty (string/trim (str (:email/subject entity))))
     [header-attribute
      {:value     (:email/subject entity)
       :attribute :email/subject}])
   [header-attribute
    {:value     (session/long->tenant-date (:common/created-on entity))
     :attribute :email/date}]])

(defn associations-view
  [{:keys [email email-id state local-entities show? on-update-email-success]}]
  (let [tenant-schema @session/tenant-schema
        email-atom (when email-id
                     (if local-entities
                       (r/cursor local-entities [email-id])
                       (r/cursor session/entities [email-id])))
        meta-params {:local-atom        (if email-id email-atom state)
                     :entity-id         email-id
                     :entity-atom       (if email-id email-atom state)
                     :metadata-template (editor-utils/resolve-activity-template
                                         {:raw-schema (merge (schema-registry/get-schema
                                                              tenant-schema
                                                              :related-entities)
                                                             (schema-registry/get-schema
                                                              tenant-schema
                                                              :entity.type/activity))})
                     :entity-type       :related-entities
                     :update-draft!     (fn [k v & rest]
                                          (swap! state assoc k v)
                                          (actions-entity/*->field-update!
                                           (:db/id email)
                                           k
                                           v
                                           (fn [_]
                                             (when (fn? on-update-email-success)
                                               (on-update-email-success)))
                                           (fn [_]
                                             (logging/error "TODO: update Error"))))}]
    [:div
     
     {:class             (uu/cm "flex-1 bg-base-regular p-3"
                         (when (and (plan/available :feature/nylas-integration
                                                    @session/tenant
                                                    @session/role)
                                    (:account/nylas-account-id @session/account)
                                    (not show?))
                          "hidden"))}
     [editor-utils/metadata-view meta-params]]))

(defn body-block
  [{:keys [email email-id state view-state local-entities on-update-email-success]}]
  (let [show-assoc? (:associations-visible? @view-state)]
    [:div 
     {:class "py-3 flex flex-auto gap-3"}
     [:div 
      {:class "flex-1"}
      [viewer-view email]]
     [associations-view
      {:email          email
       :email-id       email-id
       :state          state
       :local-entities local-entities
       :show?          show-assoc?
       :on-update-email-success on-update-email-success}]]))

(defn attachments-block
  [nev-entity-id attachments]
  (when (> (count attachments) 0)
    (let [nev-entity (get @session/entities nev-entity-id)
          entity-attachments (:common/attachments nev-entity)]
      [:ul
       {:class "flex flex-col gap-3"}
       (doall
        (for [id attachments]
          ^{:key (str "email-editor_attachment-" id)}
          [:li
           {:class "flex items-center gap-4"}
           [:span
            {:class "flex items-center gap-3"}
            [:i.fal.fa-paperclip]
            [:span 
             {:class "font-bold"}
             (entity/display-string (or (get @session/entities id) id))]]
           [:span
            {:class "flex gap-2 *:p-0"}
            [button/secondary-open 
             {:tooltip (loc/tr :open)
              :on-click #(fu/open-attachment! id)}
             [:i.fal.fa-external-link.mr-1]]
            
            [button/secondary-open
             {:tooltip (loc/tr :download)
              :on-click   #(fu/download-attachment! id)}
             [:i
              {:class "fal fa-cloud-download"}]]
            
            (when-not (some #{id} entity-attachments)
              [button/secondary-open
               {:tooltip (loc/tr :copy-to-specific-entity-attachments
                             [(cu/str-trim-lcase (loc/tr (:entity/type nev-entity)))])
                :on-click (fn [_]
                            (let [updated-attachment-ids (->> nev-entity
                                                              :common/attachments
                                                              (set/union #{id})
                                                              (remove nil?))]
                              (actions-entity/*->field-update! nev-entity-id
                                                               :common/attachments
                                                               updated-attachment-ids
                                                               (fn [_])
                                                               (fn [_]))))}
               [:i
                {:class "fal fa-download"}]])]]))])))

(defn view
  [{:keys [shown? close-modal! props state topmost?]}]
  (let [view-state (r/cursor state [:view-state])
        {:keys [email-id viewed-entity-id local-entities]} props
        _ (when-not local-entities
            (logging/warn "No local-entities passed for email-viewer-modal"))
        entities-state (cond (get @local-entities email-id)
                             local-entities
                             (get @session/entities email-id)
                             session/entities)
        email (get @entities-state email-id)]
    (reset! state {:common/related-entities (when email
                                              (set (:common/related-entities
                                                    email)))})
    (fn [{:keys [shown? close-modal! props state topmost?]}]
      (let [{:keys [email-id viewed-entity-id local-entities on-update-email-success]} props
            _ (when-not local-entities
                (logging/warn "No local-entities passed for email-viewer-modal"))
            entities-state (cond (get @local-entities email-id)
                                 local-entities
                                 (get @session/entities email-id)
                                 session/entities)
            email (get @entities-state email-id)
            subject (str (:email/subject email))
            from (:email/from email)
            to (:email/to email)
            cc (:email/cc email)
            attachments (:common/attachments email)
            show-assoc? (:associations-visible? @view-state)
            assoc-count (count (:common/related-entities email))
            tenant @session/tenant
            tenant-schema @session/tenant-schema]
        [modal/view
         {:visible?      (and shown? topmost?)
          :hide!         close-modal!
          :backdrop      "static"
          :close-button? true}
         (loc/tr :email)
         [:<>
          [header-block email]

          [body-block
           {:email          email
            :email-id       email-id
            :state          state
            :local-entities local-entities
            :view-state     view-state
            :on-update-email-success on-update-email-success}]
          [attachments-block viewed-entity-id attachments]]
         (when (and (plan/available :feature/nylas-integration tenant @session/role)
                    (:account/nylas-account-id @session/account))
           [:<>
            [:div
             {:class "flex justify-start items-center gap-3"}
             ;TIMO need help to check logic for this toggle
             [toggle/toggle
              {:checked?   (= :privacy-status/private
                              (:email/privacy-status (if (:email/privacy-status @state)
                                                       @state
                                                       email)))
               :on-change (fn [e on?]
                            (let [new-status (if on?
                                               :privacy-status/private
                                               :privacy-status/public)]
                              (swap! state assoc :email/privacy-status new-status)
                              (actions-entity/*->field-update!
                               email-id
                               :email/privacy-status
                               new-status
                               (fn [_]
                                 (js/setTimeout (fn [_]
                                                  (swap! state dissoc
                                                         :email/privacy-status))
                                                500)
                          
                                 (when (fn? on-update-email-success)
                                   (on-update-email-success)))
                               (fn [_]
                                 (logging/error
                                  "TODO : error status on setting privacy")))))}]
            ;;  [editor
            ;;   (merge {:value           (= :privacy-status/private
            ;;                               (:email/privacy-status (if (:email/privacy-status @state)
            ;;                                                        @state
            ;;                                                        email)))
            ;;           :tenant          tenant
            ;;           :tenant-schema   tenant-schema
            ;;           :editor/type     :editor.type/toggle
            ;;           :toggle-on-text  "Private"
            ;;           :toggle-off-text "Public"
            ;;           :on-change!      (fn [e on?]
            ;;                              (let [new-status (if on?
            ;;                                                 :privacy-status/private
            ;;                                                 :privacy-status/public)]
            ;;                                (swap! state assoc :email/privacy-status new-status)
            ;;                                (actions-entity/*->field-update!
            ;;                                 email-id
            ;;                                 :email/privacy-status
            ;;                                 new-status
            ;;                                 (fn [_]
            ;;                                   (js/setTimeout (fn [_]
            ;;                                                    (swap! state dissoc
            ;;                                                           :email/privacy-status))
            ;;                                                  500)

            ;;                                   (when (fn? on-update-email-success)
            ;;                                     (on-update-email-success)))
            ;;                                 (fn [_]
            ;;                                   (logging/error
            ;;                                    "TODO : error status on setting privacy")))))}
            ;;          (when (not= (:email/owner email) (:db/id @session/account))
            ;;            {:disabled? true}))]
             [button/primary-solid
              {:on-click #(events/reply viewed-entity-id email)}
              [:i.fal.fa-reply]
              [:span
               (loc/tr :reply)]]
             [button/secondary-hollow
              {:on-click #(events/reply-all viewed-entity-id email)}
              [:i.fal.fa-reply-all]
              [:span
               (loc/tr :reply-all)]]
             [button/secondary-hollow
              {:on-click #(events/forward viewed-entity-id email)}
              [:i.fal.fa-forward]
              [:span
               (loc/tr :forward)]]]
            (when-not (= @session/role :role/guest-buy-side)
              [:div
               {:class (uu/cm "flex gap-3 items-center justify-start"
                              (when-not show-assoc? "flex"))}
               [button/secondary-open
                {:on-click (fn [_]
                             (swap! view-state assoc :associations-visible? (not show-assoc?)))}
                (loc/tr (if (= 1 assoc-count)
                      :email/associations-with-1-entity
                      :email/associations-with-n-entities)
                    [assoc-count])
                [:i
                 {:class-name (fu/cs :fal
                                     (if show-assoc?
                                       :fa-chevron-up
                                       :fa-chevron-down))}]]])])]))))
